import { Col, Collapse, Row, Typography } from "antd";
import React from "react";
import { BOM } from "../../../../../services/definedMethod";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const AccountDetail = (props) => {
  const { accountDetails } = props;

  return (
    <Row>
      <Col span={24}>
        <Collapse
          style={{
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
            marginBottom: 25,
          }}
        >
          <Panel
            header={
              <Title level={5} style={{ margin: 0 }}>
                Account Detail
              </Title>
            }
            key="1"
          >
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>Repayment Strategy </Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.transactionProcessingStrategyName}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Repayments</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.numberOfRepayments} every{" "}
                    {accountDetails?.repaymentEvery}{" "}
                    {accountDetails?.repaymentFrequencyType?.value}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Amortization</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.amortizationType?.value}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Equal Amortization</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.isEqualAmortization === true
                      ? "true"
                      : "false"}{" "}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Interest</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text
                    style={{ color: "#b8b8b8" }}
                  >{`${accountDetails?.annualInterestRate} Per annum (${accountDetails?.interestRatePerPeriod}% ${accountDetails?.interestRateFrequencyType?.value}) - ${accountDetails?.interestType?.value}`}</Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Grace: On Principal Payment</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.graceOnPrincipal
                      ? accountDetails?.graceOnPrincipal
                      : "-"}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Grace: On Interest Payment</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.graceOnInterest
                      ? accountDetails?.graceOnInterest
                      : "-"}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Grace on Arrears Ageing</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.graceOnArrears
                      ? accountDetails?.graceOnArrears
                      : "-"}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Fund Source</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.fundSource
                      ? accountDetails?.fundSource
                      : "-"}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Interest Free Period</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.interestFreePeriod
                      ? accountDetails?.interestFreePeriod
                      : "-"}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Interest Calculation Period</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.interestCalculationPeriodType?.value}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>
                    Allow Partial Interest Calculation with same as repayment
                  </Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.allowPartialPeriodInterestCalcualtion ===
                    false
                      ? "false"
                      : true}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Interest Type</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.interestType?.value}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Submitted on</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {BOM.FormatArrayDate(
                      accountDetails?.timeline?.submittedOnDate
                    )}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Approved on</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {BOM.FormatArrayDate(
                      accountDetails?.timeline?.approvedOnDate
                    )}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Disbursed on</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {BOM.FormatArrayDate(
                      accountDetails?.timeline?.expectedDisbursementDate
                    )}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Matures on</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {BOM.FormatArrayDate(
                      accountDetails?.timeline?.expectedMaturityDate
                    )}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Recalculate Interest</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.isInterestRecalculationEnabled === false
                      ? "false"
                      : "true"}
                  </Text>
                </Col>
              </Row>
            </div>
            {accountDetails?.isInterestRecalculationEnabled === true && (
              <div
                style={{
                  border: "2px solid #F5F5F5",
                  borderRadius: 0,
                  borderBottomColor: "#E2E2E2",
                }}
              >
                <Row>
                  <Col
                    span={12}
                    style={{
                      backgroundColor: "#F5F5F5",
                      padding: 10,
                      borderRadius: 0,
                    }}
                  >
                    <Text strong>Interest recalculation compounding on</Text>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      padding: 10,
                    }}
                  >
                    <Text style={{ color: "#b8b8b8" }}>
                      {
                        accountDetails?.interestRecalculationData
                          ?.interestRecalculationCompoundingType?.value
                      }
                    </Text>
                  </Col>
                </Row>
              </div>
            )}
            {accountDetails?.isInterestRecalculationEnabled === true && (
              <div
                style={{
                  border: "2px solid #F5F5F5",
                  borderRadius: 0,
                  borderBottomColor: "#E2E2E2",
                }}
              >
                <Row>
                  <Col
                    span={12}
                    style={{
                      backgroundColor: "#F5F5F5",
                      padding: 10,
                      borderRadius: 0,
                    }}
                  >
                    <Text strong>Advance payments adjustment type</Text>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      padding: 10,
                    }}
                  >
                    <Text style={{ color: "#b8b8b8" }}>
                      {
                        accountDetails?.interestRecalculationData
                          ?.rescheduleStrategyType?.value
                      }
                    </Text>
                  </Col>
                </Row>
              </div>
            )}
            {accountDetails?.isInterestRecalculationEnabled === true && (
              <div
                style={{
                  border: "2px solid #F5F5F5",
                  borderRadius: 0,
                  borderBottomColor: "#E2E2E2",
                }}
              >
                <Row>
                  <Col
                    span={12}
                    style={{
                      backgroundColor: "#F5F5F5",
                      padding: 10,
                      borderRadius: 0,
                    }}
                  >
                    <Text strong>
                      Frequency for recalculate Outstanding Principal
                    </Text>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      padding: 10,
                    }}
                  >
                    <Text
                      style={{ color: "#b8b8b8" }}
                    >{`${accountDetails?.interestRecalculationData?.recalculationRestFrequencyType?.value} on ${accountDetails?.interestRecalculationData?.recalculationRestFrequencyNthDay?.value} ${accountDetails?.interestRecalculationData?.recalculationRestFrequencyWeekday?.value}`}</Text>
                  </Col>
                </Row>
              </div>
            )}
            {accountDetails?.isInterestRecalculationEnabled === true && (
              <div
                style={{
                  border: "2px solid #F5F5F5",
                  borderRadius: 0,
                  borderBottomColor: "#E2E2E2",
                }}
              >
                <Row>
                  <Col
                    span={12}
                    style={{
                      backgroundColor: "#F5F5F5",
                      padding: 10,
                      borderRadius: 0,
                    }}
                  >
                    <Text strong>Frequency for compounding</Text>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      padding: 10,
                    }}
                  >
                    <Text style={{ color: "#b8b8b8" }}>
                      {
                        accountDetails?.interestRecalculationData
                          ?.compoundingCalendarData?.humanReadable
                      }
                    </Text>
                  </Col>
                </Row>
              </div>
            )}
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 0,
                  }}
                >
                  <Text strong>Days In Year</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.daysInYearType?.value}
                  </Text>
                </Col>
              </Row>
            </div>
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              }}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderTopLeftRadius: 0,
                  }}
                >
                  <Text strong>Days In Month</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text style={{ color: "#b8b8b8" }}>
                    {accountDetails?.daysInMonthType?.value}
                  </Text>
                </Col>
              </Row>
            </div>
          </Panel>
        </Collapse>
      </Col>
    </Row>
  );
};

export default AccountDetail;
